const actions = {
  GET_BATCH_PUSH_TASK_STATUS: 'GET_BATCH_PUSH_TASK_STATUS',
  GET_BATCH_PUSH_TASK_STATUS_ENDED: 'GET_BATCH_PUSH_TASK_STATUS_ENDED',
  TRIGGER_PUSH_TASK_TO_STOP: 'TRIGGER_PUSH_TASK_TO_STOP',
  TRIGGER_PUSH_TASK_TO_STOP_ENDED: 'TRIGGER_PUSH_TASK_TO_STOP_ENDED',
};

export default actions;
